'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.Column = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  align-items: ', ';\n  align-self: ', ';\n  justify-content: ', ';\n\n  box-sizing: border-box;\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  align-items: ', ';\n  align-self: ', ';\n  justify-content: ', ';\n\n  box-sizing: border-box;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  align-items: ', ';\n  align-self: ', ';\n  justify-content: ', ';\n\n  box-sizing: border-box;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  align-items: ', ';\n  align-self: ', ';\n  justify-content: ', ';\n\n  box-sizing: border-box;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Column = exports.Column = _styledComponents2.default.div(_templateObject, function (_ref) {
  var reverse = _ref.reverse;
  return reverse ? 'column-reverse' : 'column';
}, function (_ref2) {
  var horizontal = _ref2.horizontal;
  return horizontal || 'initial';
}, function (_ref3) {
  var self = _ref3.self;
  return self || 'initial';
}, function (_ref4) {
  var vertical = _ref4.vertical;
  return vertical || 'initial';
});
var Row = exports.Row = _styledComponents2.default.div(_templateObject2, function (_ref5) {
  var reverse = _ref5.reverse;
  return reverse ? 'row-reverse' : 'row';
}, function (_ref6) {
  var vertical = _ref6.vertical;
  return vertical || 'initial';
}, function (_ref7) {
  var self = _ref7.self;
  return self || 'initial';
}, function (_ref8) {
  var horizontal = _ref8.horizontal;
  return horizontal || 'initial';
});
//# sourceMappingURL=layout.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-material/dist/src/layout.js
 ** module id = 118
 ** module chunks = 0
 **/